import config from '../config';

export default function assetUrl(assetPath) {
    if (config.assetsManifest[assetPath]) {
        return `${config.assets.baseUrl}${config.assetsManifest[assetPath]}`;
    }

    return `${config.assets.baseUrl}${assetPath}`;
}
